import React from 'react'
import type { FormFieldItem, FormDataType } from './types'

export default function FormFields({
    fields,
    formData,
    onChange,
}: {
    fields: FormFieldItem[]
    formData: FormDataType
    onChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void
}) {
    return (
        <>
            {fields.map(field => (
                <React.Fragment key={field.name}>
                    <dt>
                        {field.required && <span>必須</span>}
                        {field.label}
                    </dt>
                    <dd>
                        {field.type === 'textarea' ? (
                            <textarea
                                name={field.name}
                                value={
                                    formData[
                                        field.name as keyof FormDataType
                                    ] as string
                                }
                                onChange={onChange}
                            />
                        ) : (
                            <input
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                className={field.inputClassName}
                                value={
                                    formData[
                                        field.name as keyof FormDataType
                                    ] as string
                                }
                                onChange={onChange}
                                required={field.required}
                            />
                        )}
                    </dd>
                </React.Fragment>
            ))}
        </>
    )
}
